function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.51562 0.871094L3.37891 6.02734L1.48438 4.13281C1.44531 4.08073 1.39323 4.05469 1.32812 4.05469C1.26302 4.05469 1.20443 4.08073 1.15234 4.13281L0.605469 4.67969C0.553385 4.73177 0.527344 4.79036 0.527344 4.85547C0.527344 4.92057 0.553385 4.97266 0.605469 5.01172L3.20312 7.62891C3.25521 7.66797 3.3138 7.6875 3.37891 7.6875C3.44401 7.6875 3.49609 7.66797 3.53516 7.62891L9.39453 1.76953C9.44661 1.71745 9.47266 1.65885 9.47266 1.59375C9.47266 1.52865 9.44661 1.47656 9.39453 1.4375L8.84766 0.871094C8.79557 0.832031 8.73698 0.8125 8.67188 0.8125C8.60677 0.8125 8.55469 0.832031 8.51562 0.871094Z",
  fill: "currentColor"
});

var SvgBoldCheck = function SvgBoldCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBoldCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bold-check.86e767f5.svg";
export { ForwardRef as ReactComponent };